import {
  UPDATE_OPPORTUNITIES_TOTAL_PAGES,
} from '../actionTypes';

let initialState = []

export default function opportunitiesTotalPages(state = initialState, action) {
  switch(action.type) {
    case UPDATE_OPPORTUNITIES_TOTAL_PAGES:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/projectFinder/reducers/opportunitiesTotalPages.js